// Keep these sorted by country display name in en-US (to match the country-name filter)
const SUPPORTED_COUNTRY_CODES = [
  "AU",
  "AT",
  "BE",
  "CA",
  "HR",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IN",
  "IE",
  "IT",
  "JP",
  "LV",
  "LT",
  "LU",
  "MX",
  "NL",
  "NZ",
  "NO",
  "PH",
  "PL",
  "PT",
  "RO",
  "SG",
  "SK",
  "SI",
  "KR",
  "ES",
  "SE",
  "CH",
  "AE",
  "GB",
  "US"
];

function getFee(v) {
  return v * .05 + .5;
}

function isVisa(id) {
  return (id || '').includes('VISA') || (id == 'Q24BD9EZ332JT');
}

export { SUPPORTED_COUNTRY_CODES, getFee, isVisa };
